import { PinLevelPermissionCheckbox } from "./PinLevelPermissionCheckbox";

export default PinLevelPermissionCheckbox;
